import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-164" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-165" data-mp="2vpg2hzwmgreg">
        <div className="text-center" data-id="element-166" data-mp="2voo64mv7apn4">
          <SectionHeading id="problem-title" data-id="element-167" data-mp="39h4em36vffvf">Does This Sound Familiar?</SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-muted" data-id="element-168" data-mp="35gty3wlgd72b">
            You're working with industrial automation and PLC systems but struggle with gaps in technical understanding.
            When colleagues ask about PLC architecture, control logic, sensor signals, HMI integration, or troubleshooting
            problems, you can't confidently explain the technical reasons.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-electric/30 bg-surface p-6 shadow-glow sm:p-8" data-id="element-169" data-mp="1k49aflojkq7i">
          <p className="mb-5 inline-flex items-center gap-2 font-display text-2xl font-bold uppercase text-foreground" data-id="element-170" data-mp="sbywi7ud3zyf">
            <AlertTriangleIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-171" data-mp="1244jt49o5t7a" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-172" data-mp="171mvv3izgoji">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-173" data-mp="1c228ttzcru0y">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-electric shadow-[0_0_8px_rgba(0,207,255,0.7)]" aria-hidden="true" data-id="element-174" data-mp="1g3dx9w6hq97k" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-175" data-mp="3hu7mzca706ta">
          <p className="mx-auto max-w-2xl text-lg font-bold text-foreground" data-id="element-176" data-mp="3hv0tqd95iwbf">
            Stop wasting personal time. You're already experienced. What you need is the right tool.
          </p>
          <p className="mt-3 font-display text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-177" data-mp="k2qsq2so8x7l">
            Build your entire <span className="text-electric" data-id="element-178" data-mp="tzlmk8e029fj">automation knowledge</span> today.
          </p>
        </div>
      </div>
    </section>;
}